import { Component, OnInit } from "@angular/core";
import { CONSTANTS } from "app/constants";

@Component({
    selector: 'drawind-national-cups',
    templateUrl: 'national-cups.page.html',
    styleUrls: ['national-cups.page.scss'],
})
export class DrawingNationalCupsPage implements OnInit {
    stages: any[] = [];

    currentTab: number = 0;

    const;
    
    constructor() {
        this.const = CONSTANTS;
    }

    ngOnInit(): void {
        this.buildEuroStagesDictionary();
    }

    changeTab(tab: number) {
        this.currentTab = tab;
    }

    private buildEuroStagesDictionary() {
        this.stages = [];
        this.stages.push({key: CONSTANTS.euroCupStages.playoff32, name: CONSTANTS.euroCupStagesNames.playoff32});
        this.stages.push({key: CONSTANTS.euroCupStages.playoff16, name: CONSTANTS.euroCupStagesNames.playoff16});
        this.stages.push({key: CONSTANTS.euroCupStages.playoff8, name: CONSTANTS.euroCupStagesNames.playoff8});
        this.stages.push({key: CONSTANTS.euroCupStages.playoff4, name: CONSTANTS.euroCupStagesNames.playoff4});
        this.stages.push({key: CONSTANTS.euroCupStages.playoff2, name: CONSTANTS.euroCupStagesNames.playoff2});
        this.stages.push({key: CONSTANTS.euroCupStages.final, name: CONSTANTS.euroCupStagesNames.final});
    }
    
}